export default __webpack_public_path__ + "static/media/47_photo.ecbcb805.jpg";